import { NgxSpinnerModule } from 'ngx-spinner';
import { LoadingProgressComponent } from './shared/loading-progress/loading-progress.component';
import { CommonModule, registerLocaleData } from "@angular/common";
import localeHr from '@angular/common/locales/hr';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from "@angular/common/http";
import { ErrorHandler, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthModule, AuthService } from "@auth0/auth0-angular";
import { FootballerAuthService, usesFootballerAuth } from './shared/services/footballer-auth.service';
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TabsModule } from "ngx-bootstrap/tabs";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ChatModule } from "./chat/chat.module";
import { CoreModule } from "./core/core.module";
import { DialogComponent } from "./core/dialog/dialog.component";
import { environment, auth0LockConfig } from "./environments/environment";
import { EventModule } from "./event/event.module";
import { FeedbackModule } from "./feedback/feedback.module";
import { HelpModule } from "./help/help.module";
import { PlayerModule } from "./player/player.module";
import { PlaySpaceModule } from "./playspace/play-space.module";
import { NavBarComponent } from "./shared/nav-bar/nav-bar.component";
import { KeysPipe } from "./shared/pipes/keys.pipe";
import Auth0InterceptorApi from "./shared/services/auth0.interceptor";
import { GuestOwnerService } from "./shared/services/guest-owner.service";
import { GuestOwnerSessionService } from "./shared/services/guest-owner-session.service";
import { LogService } from "./shared/services/log.service";
import { CustomErrorHandler } from "./shared/utils/custom.error.handler";
import { FooterModule } from "./footer/footer.module";
import { GoogleMapsModule } from '@angular/google-maps';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { HttpClient } from '@angular/common/http';
import { NogoshIconPipe } from './shared/icons/nogosh-icon.pipe';
import { ScreenShellComponent } from "./shared/screen-shell/screen-shell.component";
import { EmailVerificationResultComponent } from "./email-verification-result/email-verification-result.component";

export function httpTranslateLoader(http: HttpClient) {
  // Translation assets must follow the deployed bundle, not an older browser cache.
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=[[WEB_COMMIT_ID]]');
}

registerLocaleData(localeHr);

@NgModule({ declarations: [AppComponent, KeysPipe, NavBarComponent, EmailVerificationResultComponent],
    exports: [KeysPipe, DialogComponent, BsDropdownModule],
    bootstrap: [AppComponent], imports: [BrowserModule, NgxSpinnerModule, LoadingProgressComponent,
        AppRoutingModule,
        FormsModule,
        CommonModule,
        CoreModule,
        ChatModule,
        //AgmCoreModule.forRoot({
        //apiKey: environment.apiKey,
        //}),
        GoogleMapsModule,
        BsDatepickerModule,
        TimepickerModule,
        TypeaheadModule,
        TabsModule,
        ButtonsModule,
        BsDropdownModule,
        PopoverModule,
        BrowserAnimationsModule,
        InfiniteScrollModule,
        PlayerModule,
        PlaySpaceModule,
        EventModule,
        FeedbackModule,
        HelpModule,
        FooterModule,
        ScreenShellComponent,
        ...(usesFootballerAuth ? [] : [AuthModule.forRoot({
            domain: auth0LockConfig.domain,
            clientId: environment.AUTH0_CLIENT_ID,
            authorizationParams: {
                audience: environment.AUTH0_AUDIENCE,
                scope: "openid profile email offline_access",
                redirect_uri: window.location.origin
            },
            useRefreshTokens: true,
            useRefreshTokensFallback: true,
            cacheLocation: 'localstorage',
            httpInterceptor: {
                allowedList: [{ uri: `${environment.API_BASE_URL}/**` }],
            },
        })]),
        RatingModule,
        NogoshIconPipe,
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient]
            },
            compiler: {
                provide: TranslateCompiler,
                useClass: TranslateMessageFormatCompiler
            }
        })], providers: [
        {
            provide: ErrorHandler,
            useClass: CustomErrorHandler,
        },
        LogService,
        ...(usesFootballerAuth ? [{ provide: AuthService, useExisting: FootballerAuthService }] : []),
        GuestOwnerService,
        GuestOwnerSessionService,
        { provide: HTTP_INTERCEPTORS, useClass: Auth0InterceptorApi, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ConnectionStateInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ] })
export class AppModule {}
import { ConnectionStateInterceptor } from './shared/services/connection-state.interceptor';
